'use client';

import { useRouter } from 'next/navigation';
import { useLayoutEffect } from 'react';

import Loader from '@/ui/loader/loader';

export default function NotFound() {
  const router = useRouter();

  useLayoutEffect(() => {
    router.replace('/en-US/error-page');
  });

  return (
    <Loader size={18} />
  );
}
